import { render, staticRenderFns } from "./recommend.vue?vue&type=template&id=54ea0252&scoped=true&"
import script from "./recommend.vue?vue&type=script&lang=js&"
export * from "./recommend.vue?vue&type=script&lang=js&"
import style0 from "./recommend.vue?vue&type=style&index=0&id=54ea0252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ea0252",
  null
  
)

export default component.exports